<template>
  <v-tooltip bottom :color="schema.tooltipColorClass">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        :data-has-tooltip="schema.tooltip ? 'true' : 'false'"
        :data-tooltip="schema.tooltip"
        :name="schema.model"
        :id="schema.model"
        :href="computedValue"
        @click="checkIsFileDownload"
        v-bind="[schema.attributesButton, attrs]"
        @contextmenu="selectComponentDEV($event, schema.model)"
        :class="[getSelectedDEV && 'dev-selected-component', schema.attributesButton.class]"
      >
        <v-icon v-if="schema.attributesIcon && schema.attributesIcon.showIconLeft" v-bind="schema.attributesIcon">
          {{ schema.attributesIcon.icon }}
        </v-icon>
        {{ schema.attributesButton.label }}
        <v-icon v-if="schema.attributesIcon && schema.attributesIcon.showIconRight" v-bind="schema.attributesIcon">
          {{ schema.attributesIcon.icon }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ schema.tooltip }}</span>
  </v-tooltip>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import componentsLinkMixins from '@/mixins/components-link-mixins';
import { sleep } from '@/helpers/page';

export default {
  mixins: [abstractField, devComponentMixin, componentsLinkMixins],

  props: {
    schema: { type: Object, default: () => ({}) }
  },

//TODO: desativar este item pois desalinha botões em diferentes de pagina.
// Remover do código após 20/04/2023
  // mounted() {
  //   this.alignButtons();
  // },

  methods: {
    //TODO: desativar este item pois desalinha botões em diferentes de pagina.
    async alignButtons() {
      await sleep(1000);
      let listButtons = document.querySelectorAll('.field-i4proButtonLink');

      if (listButtons.length > 1) {
        let paddingLeft = 0;
        let lastItem = listButtons[listButtons.length - 1];
        let itemCurrent = document.querySelector(`#${this.schema.model}`);

        for (let item = 0; item < listButtons.length; item++) {
          if (listButtons[item].offsetWidth) {
            let paddingInit = 0;

            if (item > 0) paddingInit += 20;

            if (item == 1) paddingInit += 15;

            paddingLeft += parseInt(listButtons[item].querySelector('.v-btn').offsetWidth) + paddingInit;

            // se o id do item corrente do array for igual ao item corrente, sai do for e para de add espaço
            if (listButtons[item].querySelector('.v-btn').id == this.schema.model) break;
          }
        }

        // se o id do primeiro item for diferente do id atual, aplica o espaço
        if (listButtons[0].querySelector('.v-btn').id != this.schema.model) {
          itemCurrent.style.left = paddingLeft - itemCurrent.offsetWidth + 'px';
        }
      }
    },

    handleLinkClick() {
      if (attributesSchemaComponent().target) {
        window.open(this.computedValue, attributesSchemaComponent().target);
      }

      window.open(this.computedValue);
    },
  }
};
</script>
